<ion-app id="main-content">
  <app-header></app-header>
  <ion-content>
    <ion-router-outlet></ion-router-outlet>
  </ion-content>
</ion-app>